import styles from "./UserHistoryAction.module.css";

const UserHistoryAction = ({ action }) => {
  return (
    <>
      <p className={styles["history-item"]}>
        Поле:{" "}
        <span className={styles["history-item__value"]}>
          {action?.fieldName}
        </span>
      </p>
      <p className={styles["history-item"]}>
        Исходное значение:{" "}
        <span className={styles["history-item__value"]}>
          {action?.oldValue}
        </span>
      </p>
      <p className={styles["history-item"]}>
        Новое значение:{" "}
        <span className={styles["history-item__value"]}>
          {action?.newValue}
        </span>
      </p>
    </>
  );
};

export default UserHistoryAction;
